// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);
}

.pricing-container {
  flex: 1 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  width: 100%;
}

.pricing-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 3rem;
}

/* Billing Toggle */
.billing-toggle {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 3rem;
  background-color: #f5f5f5;
  padding: 0.5rem;
  border-radius: 0.5rem;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.toggle-btn {
  padding: 0.75rem 2rem;
  border: none;
  background-color: transparent;
  color: #64748b;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 0.4rem;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggle-btn.active {
  background-color: #ffffff;
  color: #0f172a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.toggle-btn:hover {
  color: #0f172a;
}

.save-badge {
  background-color: #28a745;
  color: #ffffff;
  padding: 0.25rem 0.5rem;
  border-radius: 0.3rem;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Pricing Cards */
.pricing-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

.pricing-card {
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.pricing-card.popular {
  border: 2px solid #28a745;
  transform: scale(1.05);
}

.pricing-card.popular:hover {
  transform: scale(1.05) translateY(-8px);
}

.popular-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #28a745;
  color: #ffffff;
  padding: 0.5rem 1.5rem;
  border-radius: 2rem;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.plan-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.5rem;
  text-align: center;
}

.plan-price {
  text-align: center;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.original-price {
  font-size: 1rem;
  color: #94a3b8;
  text-decoration: line-through;
}

.price {
  font-size: 3rem;
  font-weight: 700;
  color: #0f172a;
}

.price:not([data-numeric]) {
  font-size: 2rem;
}

.period {
  font-size: 1rem;
  color: #64748b;
  margin-left: 0.5rem;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  flex: 1 1;
}

.plan-features li {
  padding: 0.75rem 0;
  color: #475569;
  font-size: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  border-bottom: 1px solid #f1f5f9;
}

.plan-features li:last-child {
  border-bottom: none;
}

.check-icon {
  color: #28a745;
  font-weight: 700;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.plan-button {
  width: 100%;
  padding: 1rem 2rem;
  border: 2px solid #28a745;
  background-color: #ffffff;
  color: #28a745;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.plan-button:hover {
  background-color: #28a745;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.plan-button.popular-btn {
  background-color: #28a745;
  color: #ffffff;
}

.plan-button.popular-btn:hover {
  background-color: #218838;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

/* Need More Section */
.need-more {
  text-align: center;
  margin-bottom: 2rem;
}

.need-more p {
  font-size: 1.1rem;
  color: #0f172a;
}

.need-more a {
  color: #28a745;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.need-more a:hover {
  border-bottom-color: #28a745;
}

/* Disclaimer */
.pricing-disclaimer {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.pricing-disclaimer p {
  font-size: 0.9rem;
  color: #64748b;
  margin-bottom: 0.75rem;
}

.pricing-disclaimer a {
  color: #28a745;
  text-decoration: none;
  font-weight: 500;
}

.pricing-disclaimer a:hover {
  text-decoration: underline;
}

.academic-notice {
  font-size: 0.85rem !important;
  color: #94a3b8 !important;
  font-style: italic;
}

.read-more-link {
  color: #28a745;
  text-decoration: none;
  font-weight: 600;
  font-style: normal;
}

.read-more-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .pricing-cards {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
  
  .pricing-card.popular {
    transform: scale(1);
  }
  
  .pricing-card.popular:hover {
    transform: translateY(-8px);
  }
}

@media (max-width: 768px) {
  .pricing-container {
    padding: 3rem 1.5rem;
  }
  
  .pricing-title {
    font-size: 2rem;
  }
  
  .billing-toggle {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
  }
  
  .toggle-btn {
    width: 100%;
    justify-content: center;
  }
  
  .pricing-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .pricing-card {
    padding: 2rem 1.5rem;
  }
  
  .plan-name {
    font-size: 1.5rem;
  }
  
  .price {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .pricing-container {
    padding: 2rem 1rem;
  }
  
  .pricing-title {
    font-size: 1.75rem;
  }
  
  .pricing-card {
    padding: 1.5rem 1rem;
  }
  
  .plan-features li {
    font-size: 0.95rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/Pricing.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".pricing-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);\n}\n\n.pricing-container {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 4rem 2rem;\n  width: 100%;\n}\n\n.pricing-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n/* Billing Toggle */\n.billing-toggle {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 3rem;\n  background-color: #f5f5f5;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  width: fit-content;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.toggle-btn {\n  padding: 0.75rem 2rem;\n  border: none;\n  background-color: transparent;\n  color: #64748b;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  border-radius: 0.4rem;\n  transition: all 0.3s ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.toggle-btn.active {\n  background-color: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-btn:hover {\n  color: #0f172a;\n}\n\n.save-badge {\n  background-color: #28a745;\n  color: #ffffff;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.3rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Pricing Cards */\n.pricing-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n  max-width: 1100px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.pricing-card {\n  background-color: #ffffff;\n  border-radius: 1rem;\n  padding: 2.5rem 2rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.pricing-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.pricing-card.popular {\n  border: 2px solid #28a745;\n  transform: scale(1.05);\n}\n\n.pricing-card.popular:hover {\n  transform: scale(1.05) translateY(-8px);\n}\n\n.popular-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #28a745;\n  color: #ffffff;\n  padding: 0.5rem 1.5rem;\n  border-radius: 2rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n}\n\n.plan-name {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.plan-price {\n  text-align: center;\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.original-price {\n  font-size: 1rem;\n  color: #94a3b8;\n  text-decoration: line-through;\n}\n\n.price {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.price:not([data-numeric]) {\n  font-size: 2rem;\n}\n\n.period {\n  font-size: 1rem;\n  color: #64748b;\n  margin-left: 0.5rem;\n}\n\n.plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem 0;\n  flex: 1;\n}\n\n.plan-features li {\n  padding: 0.75rem 0;\n  color: #475569;\n  font-size: 1rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.plan-features li:last-child {\n  border-bottom: none;\n}\n\n.check-icon {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.plan-button {\n  width: 100%;\n  padding: 1rem 2rem;\n  border: 2px solid #28a745;\n  background-color: #ffffff;\n  color: #28a745;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.plan-button:hover {\n  background-color: #28a745;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.plan-button.popular-btn {\n  background-color: #28a745;\n  color: #ffffff;\n}\n\n.plan-button.popular-btn:hover {\n  background-color: #218838;\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n}\n\n/* Need More Section */\n.need-more {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.need-more p {\n  font-size: 1.1rem;\n  color: #0f172a;\n}\n\n.need-more a {\n  color: #28a745;\n  font-weight: 600;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: border-color 0.3s ease;\n}\n\n.need-more a:hover {\n  border-bottom-color: #28a745;\n}\n\n/* Disclaimer */\n.pricing-disclaimer {\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.pricing-disclaimer p {\n  font-size: 0.9rem;\n  color: #64748b;\n  margin-bottom: 0.75rem;\n}\n\n.pricing-disclaimer a {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.pricing-disclaimer a:hover {\n  text-decoration: underline;\n}\n\n.academic-notice {\n  font-size: 0.85rem !important;\n  color: #94a3b8 !important;\n  font-style: italic;\n}\n\n.read-more-link {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.read-more-link:hover {\n  text-decoration: underline;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .pricing-cards {\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  }\n  \n  .pricing-card.popular {\n    transform: scale(1);\n  }\n  \n  .pricing-card.popular:hover {\n    transform: translateY(-8px);\n  }\n}\n\n@media (max-width: 768px) {\n  .pricing-container {\n    padding: 3rem 1.5rem;\n  }\n  \n  .pricing-title {\n    font-size: 2rem;\n  }\n  \n  .billing-toggle {\n    flex-direction: column;\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .toggle-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .pricing-cards {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .pricing-card {\n    padding: 2rem 1.5rem;\n  }\n  \n  .plan-name {\n    font-size: 1.5rem;\n  }\n  \n  .price {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .pricing-container {\n    padding: 2rem 1rem;\n  }\n  \n  .pricing-title {\n    font-size: 1.75rem;\n  }\n  \n  .pricing-card {\n    padding: 1.5rem 1rem;\n  }\n  \n  .plan-features li {\n    font-size: 0.95rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
